module.exports = __webpack_public_path__ + "static/img/limit_05.b06e8184.svg";